import React from 'react'
import './index.css'


const Cases = () => {
    return (
        <div className='cases'>
            <div className='projects_heading'>PROJECTS</div>
            <div class='project_row'>
                <div class="imgBx">
                    <div class="card">
                        <div class="content">
                            <div class="details">
                                <h2>Action 4 Agriculture</h2>
                                <h3>React, Figma, Git</h3>
                                <h4>As a team of 10 at WDCC (Web Development and Consulting Club), we collaborated in sprint sessions to develop a website to introudce Australian students to career in the agriculture sector. I contributed towards developing lo-fi wireframes and hi-fi prototypes on Figma, before developing the front-end using React.</h4>
                                <div class="actionBtn">
                                    <a href="https://github.com/UoaWDCC/A4A"><button>More</button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="imgBx">
                    <div class="card">
                        <div class="content">
                            <div class="details">
                                <h2>UpHer</h2>
                                <h3> Figma</h3>
                                <h4> Glad to have percipitated in GirlBoss' 2 day event where in a team of four we developed a technological solution to bring us one step closer to the SDG goals. Our team aimed to provide community and support for women in the workforce who wish to take maternity leave. I contributed towards the design of the UI, and the website prototype.</h4>
                                <div class="actionBtn">
                                    <a href="https://www.figma.com/proto/TcwQMaR7YmDM2YI5QoIRRL/Untitled?scaling=scale-down-width&page-id=0%3A1&starting-point-node-id=1%3A171&node-id=1%3A171"><button>More</button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class='project_row'>
                <div class="imgBx">
                    <div class="card">
                        <div class="content">
                            <div class="details">
                                <h2>Reinforcement Learning</h2>
                                <h3>Python, TensorFlow</h3>
                                <h4>Used TensorFlow to train OpenAI classic control and Atari games with machine learning models. Optimised the scoring and used AI to teach computer to play games!</h4>
                                <div class="actionBtn">
                                    <a href="https://github.com/zhua633/COMPSYS726-Reinforcement-Learning"><button>More</button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="imgBx">
                    <div class="card">
                        <div class="content">
                            <div class="details">
                                <h2>Snake</h2>
                                <h3>Python</h3>
                                <h4>Designed a simple snake game in python.</h4>
                                <div class="actionBtn">
                                    <a href="https://github.com/zhua633/Snake"><button>More</button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class='project_row'>
                <div class="imgBx">
                    <div class="card">
                        <div class="content">
                            <div class="details">
                                <h2>Tic Tac Toe</h2>
                                <h3>Python</h3>
                                <h4>Used alpha beta pruning to teach the computer to play a game of Tic Tac Toe. Be careful because the computer almost always win!</h4>
                                <div class="actionBtn">
                                    <a href="https://github.com/zhua633/Tic-Tac-Toe"><button>More</button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="imgBx">
                    <div class="card">
                        <div class="content">
                            <div class="details">
                                <h2>Search Engine</h2>
                                <h3>Html, CSS</h3>
                                <h4>Replicated the Google search engine front-end, and learnt to use queries to search with keywords.</h4>
                                <div class="actionBtn">
                                    <a href="https://github.com/zhua633/Search"><button>More</button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>


    )
}

export default Cases;